import React from 'react';

import { BoxProps as ChakraBoxProps } from '@chakra-ui/react';

import { apiTypes } from '@app/models';

export interface ReservationPriceBoxProps extends ChakraBoxProps {
    withPrepayment: boolean;
    isRemovable?: boolean;
    currency: string | undefined;
    convertedRatesCurrency?: string;
    prepayment?: apiTypes.PrepaymentType | null;
    prepaymentDate?: Date;
    convertedTotalPrice?: number | undefined;
    totalPrice: number;
    basePrice?: number;
    convertedBasePrice?: number;
    prepaymentInfo?: React.ReactNode;
    remainingPrice?: React.ReactNode;
    withOnlinePayment?: boolean;
    guests?: number;
    childrenAges?: number[];
    nightsCount?: number;
    isAvantioAccommodation?: boolean;
}
